import { useQuery, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../../../../services/endpoints/endpoints.service";

export const useChecklists = ({ patientId }: { patientId: number }) => {
	const queryClient = useQueryClient();
	const queryKey = ["checklists", { patientId }];

	const query = useQuery({
		queryKey: queryKey,

		queryFn: async () => {
			const checklists = await EndpointsService.dataRetriever.getChecklists({
				config: {
					params: {
						patientId,
					},
				},
			});

			return checklists;
		},
	});

	return {
		...query,
		invalidate: () =>
			queryClient.invalidateQueries({
				queryKey: queryKey,
			}),
	};
};
